// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/gfa.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/gfa/gfa.js';

mount([g0]);
